module.exports = __webpack_public_path__ + "static/media/norton-secured.a1c7afd3.svg";